<template>
	<div class="bannerMessage">
		<div
			v-for="bannerMessage in bannerMessages"
			:key="bannerMessage.messageId"
			class="left-align header-left-align"
		>
			<v-alert
				border="left"
				colored-border
				elevation="2"
				outlined
				dense
				color="#EBC53D"
			>
				<template v-slot:prepend>
					<i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-information banner-message-icon" style="color: #477BA6 !important;"></i>
				</template>
				<div v-html="bannerMessage.messageBody"></div>
			</v-alert>
		</div>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';
export default {
	name: 'BannerMessage',
	props: {
	},
	data: () => ({
		bannerMessages: null
	}),
	mounted () {
		this.getBannerMessages();
	},
	methods: {
		getBannerMessages () {
			const me = this;
			researcherApiService.getBanners()
				.then(function (response) {
					if (response && response.data) {
						me.bannerMessages = response.data.data;
					}
				})
				.catch(function (e) {
					console.log(e);
				});
		}
	}
}
</script>

<style>
</style>
